import {
  NeedsActivityDto,
  NeedsCategoryDto,
  NeedsIssueDto,
  ZCodeDto,
} from '@act/shared/data-transfer-objects';
import { ColumnConfiguration } from '@act/storybook';

export const NeedsIssuesTableColumns = (
  categories: NeedsCategoryDto[],
  zcodes: ZCodeDto[],
  needActivities: NeedsActivityDto[]
): ColumnConfiguration<NeedsIssueDto>[] => [
  {
    id: 'label',
    value: 'label',
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Issue Label',
  },
  {
    id: 'categoryId',
    value: (row: NeedsIssueDto) => {
      const category = categories.find(c => c.id === row.categoryId);
      return category?.label;
    },
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Category',
  },
  {
    id: 'defaultTimeFrameInDays',
    value: 'defaultTimeFrameInDays',
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Default Time Frame',
  },
  {
    id: 'activityIds',
    value: (row: NeedsIssueDto) => {
      const activities = needActivities.filter(a =>
        row.activityIds.includes(a.id)
      );
      return activities.map(a => a.label).join(', ');
    },
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Activities',
  },
  {
    id: 'zcodeId',
    value: (row: NeedsIssueDto) => {
      const zcode = zcodes.find(z => z.id === row.zcodeId);
      return zcode?.label;
    },
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Zcode',
  },
  {
    id: 'tagCloud',
    value: 'tagCloud',
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Tag Cloud',
  },
  {
    id: 'key',
    value: 'key',
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Key',
  },
];
